import { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/aunjai-loandetail.css";
import LoadingPage from "../../components/LoadingPage/LoadingPage";
import { useUser } from "../../hooks/useUser";
import { getLoanAdvantagesText } from "../../utils/loan";
import Header from "../Header/Header";
import { Link } from "react-router-dom";

const LoanDetail = ({ loanInfo, isFetchingLoans }) => {
  const { t } = useTranslation("loanDetail");

  const bankAccountTranslations = {
    BBL: t("banks.BBL"),
    KBANK: t("banks.KBANK"),
    KTB: t("banks.KTB"),
    SCB: t("banks.SCB"),
    BAY: t("banks.BAY"),
  };

  const borrowerTypeTranslations = {
    1: t("borrowerTypes.1"),
    2: t("borrowerTypes.2"),
    3: t("borrowerTypes.3"),
  };

  const { userData } = useUser();

  const isForeigner = userData?.is_foreigner;

  const [selectedBorrowerType, setSelectedBorrowerType] = useState(1);
  const [selectedDetailImage, setSelectedDetailImage] = useState(null);

  if (isFetchingLoans) return <LoadingPage message={t("loading")} />;

  if (!loanInfo) return null;

  const acceptedBankAccount =
    loanInfo.condition[`bank_accout_type${selectedBorrowerType}`];

  const filteredBorrowerTypes = loanInfo.condition.borrower_type.filter(
    (type) => (isForeigner ? type === 1 : true)
  );

  return (
    <>
      <Header title="" showIcon showNotifications />
      <div id="pageLoanDetail">
        <div className="wrapContent">
          <div className="bBreadcrumb">
            <Link to="/">{t("home")}</Link>
            <img src="/assets/img/ci/icon/chevron-right.svg" alt="" />
            <p>{loanInfo?.name}</p>
          </div>
          <div id="pLoanDetail">
            <div className="bLoanDetail">
              <div className="bContent">
                <div className="bImg">
                  <img
                    src={
                      selectedDetailImage ??
                      loanInfo.loan_image ??
                      "/assets/img/ci/img/img-pico-full.png"
                    }
                    alt="loan"
                  />
                </div>

                {loanInfo.detail_images?.length > 0 && (
                  <div
                    className="flex gap-2 px-4 py-3 overflow-x-auto"
                    style={{ WebkitOverflowScrolling: "touch" }}
                  >
                    <button
                      onClick={() => setSelectedDetailImage(null)}
                      className="flex-shrink-0"
                    >
                      <img
                        src={
                          loanInfo.loan_image ??
                          "/assets/img/ci/img/img-pico-full.png"
                        }
                        alt="Main"
                        className="rounded-lg object-cover"
                        style={{
                          width: 80,
                          height: 80,
                          border:
                            selectedDetailImage === null
                              ? "2px solid #22c55e"
                              : "2px solid transparent",
                        }}
                      />
                    </button>
                    {loanInfo.detail_images
                      .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))
                      .map((detail) => (
                        <button
                          key={detail.id}
                          onClick={() => setSelectedDetailImage(detail.image)}
                          className="flex-shrink-0"
                        >
                          <img
                            src={detail.image}
                            alt={detail.name || "Detail"}
                            className="rounded-lg object-cover"
                            style={{
                              width: 80,
                              height: 80,
                              border:
                                selectedDetailImage === detail.image
                                  ? "2px solid #22c55e"
                                  : "2px solid transparent",
                            }}
                          />
                        </button>
                      ))}
                  </div>
                )}

                <div className="bDetail">
                  <div className="bTitle">
                    <h2>{loanInfo?.name}</h2>
                    <p>{getLoanAdvantagesText(loanInfo)}</p>
                  </div>
                  <div className="bText">
                    <h3>{t("criteriaTitle")}</h3>
                  </div>
                  <div className="bTab">
                    {filteredBorrowerTypes.map((type) => (
                      <div
                        style={{ cursor: "pointer" }}
                        className={`bLeft ${
                          selectedBorrowerType === type ? "active" : ""
                        }`}
                        onClick={() => setSelectedBorrowerType(type)}
                      >
                        <p>{borrowerTypeTranslations[type]}</p>
                      </div>
                    ))}
                  </div>

                  <section className="bTabContent">
                    <div className="bTextList">
                      <ul>
                        <li>
                          {t("ageRange")} {loanInfo.condition.minimum_age ?? 0}{" "}
                          - {loanInfo.condition.maxinum_age ?? 0}{" "}
                          {t("yearRange")}
                        </li>
                        <li>
                          {t("incomeRequirement")}{" "}
                          {
                            loanInfo.condition[
                              `monthly_amount_type${selectedBorrowerType}`
                            ]
                          }
                          {"  "}
                          {t("incomeRequirement2")}
                        </li>
                        <li>
                          {t("workExperience")}{" "}
                          {loanInfo.condition.work_exp ?? 0}{" "}
                          {t("workExperience2")}
                        </li>
                        <li>{t("addressRequirement")}</li>
                        <li>{t("salarySlipRequirement")}</li>
                        <li>
                          {t("salaryBankRequirement")}{" "}
                          {acceptedBankAccount
                            ?.map((bank) => bankAccountTranslations[bank])
                            .join("/")}
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanDetail;
